import { PersonRequest } from "@plinknz/tah-website-elements";

import { personalDetailsConfig } from "../config-generics/personal-details";
import { SurveyConfig } from "../../../components/content-blocks/forms/customer-form-types";
import { confirmationConfig } from "./confirmation";
import { emergencyContactConfig } from "./emergency-contact";
import { introConfig } from "./intro";
import { participantConfig } from "./participant-details";

export const createSurveyConfig = (member: PersonRequest): SurveyConfig => {
  const personalConfig = personalDetailsConfig(member);
  const emergencyContact = emergencyContactConfig(member);

  return {
    pages: [
      ...introConfig,
      ...personalConfig,
      ...emergencyContact,
      ...participantConfig,
      ...confirmationConfig,
    ],
  };
};
